<div
  id="eula"
  class="eula shared-main-container page-bg-tall"
  [ngClass]="{ 'eula-not-authenticated': (isAuthenticated$ | async) !== undefined }"
>
  <section class="inner one-column-page">
    <span [marked]="eulaCompleteDescription"> </span>
  </section>
</div>
